import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatSlotTime } from '@utils/dayjs';

const MatchingCapacityReportTooltip = (props) => {
    const { t } = useTranslation('bidding');

    const row = useMemo(() => props.api.getDisplayedRowAtIndex(props.rowIndex), [props.api, props.rowIndex]);
    const matchingCapacityReport = useMemo(
        () => row.data[props.column.colId].capacityReport,
        [props.column.colId, row.data]
    );
    const diffWithCapacity = useMemo(
        () => row.data[props.column.colId].differenceWithCapacity,
        [props.column.colId, row.data]
    );

    return diffWithCapacity !== undefined ? (
        <div
            style={{
                backgroundColor: 'white',
                color: 'black',
                borderRadius: '10px',
                border: '1px solid grey',
                boxShadow: '10px 10px 5px #D3D3D3',
                padding: '20px 10px',
            }}
        >
            {matchingCapacityReport && (
                <span>
                    {formatSlotTime(matchingCapacityReport.createdAt, 'DD.MM.')}: {matchingCapacityReport.value}
                </span>
            )}
            {!matchingCapacityReport && <span>{t('tooltip.noData')}</span>}
        </div>
    ) : (
        // Required so that AgGrid doesn't throw an error about the tooltip not being created in time
        <div></div>
    );
};

export default MatchingCapacityReportTooltip;
